const $ = jQuery.noConflict();

'use strict';
const EqualHeight = {
	selector: '.js-equal-height',
	disableBelow: 0, // e.g. 640 if you want to disable below 640px
	$items: null,
	_ro: null,

	init: function(selector = null, opts = {}) {
		this.selector = selector || this.selector;
		this.disableBelow = opts.disableBelow ?? this.disableBelow;

		this.$items = $(this.selector);
		if (!this.$items.length) return;

		// Initial equalization
		this.equalize();

		// Recalculate when all images are loaded
		$(window).on('load', () => this.equalize());
		this.$items.find('img').each((_, img) => {
			if (!img.complete) $(img).on('load', this.debounce(() => this.equalize(), 50));
		});

		// Debounced resize
		$(window).on('resize', this.debounce(() => this.equalize(), 120));

		// React to content changes (if the browser supports it)
		if ('ResizeObserver' in window) {
			this._ro = new ResizeObserver(() => this.equalize());
			this.$items.each((_, el) => this._ro.observe(el));
		}
	},

	equalize: function() {
		if (!this.$items || !this.$items.length) return;

		// Optionally disable on smaller widths
		if (this.disableBelow && window.innerWidth < this.disableBelow) {
			this.$items.css('min-height', '');
			return;
		}

		// Reset, then measure
		this.$items.css('min-height', '');
		let maxH = 0;

		this.$items.each((_, el) => {
			// getBoundingClientRect is more accurate (includes subpixel values)
			const h = Math.ceil(el.getBoundingClientRect().height);
			if (h > maxH) maxH = h;
		});

		if (maxH > 0) this.$items.css('min-height', maxH + 'px');
	},

	debounce: function(fn, wait = 100) {
		let t;
		return (...args) => {
			clearTimeout(t);
			t = setTimeout(() => fn.apply(this, args), wait);
		};
	},
};

export default EqualHeight;
